#import '../fragments/onboarding-module-fragment.graphql'

query GetCustomerOnboarding {
    customerOnboarding {
        shownModules {
            ...OnboardingModuleFragment
        }
        hiddenModules {
            ...OnboardingModuleFragment
        }
    }
}
